module.exports = __webpack_public_path__ + "static/media/url_to_widget3.6ea36b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/adminPanel/Content Management/assets/url_to_widget3.png
// module id = 1408
// module chunks = 1